import { Fade, Paper } from "@material-ui/core";
export const AppPaper = ({ children }) => {
    return (
        <Fade in timeout={500} mountOnEnter unmountOnExit>
            <Paper style={{ marginTop: 24, marginBottom: 24, borderRadius: ".25rem", overflow: "auto", boxShadow: "0 0.5em 1em -0.125em rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.02)", transition: "height 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"}}>{children}</Paper>
        </Fade>
    )
}
